import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d2979d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_6 = {
  class: "bold flex",
  style: {"color":"#000000"}
}
const _hoisted_7 = { class: "van-cell__title" }
const _hoisted_8 = { style: {"font-size":"0.32rem"} }
const _hoisted_9 = { class: "high-light" }
const _hoisted_10 = {
  key: 0,
  style: {"padding":"0"}
}
const _hoisted_11 = { class: "van-cell__title" }
const _hoisted_12 = { style: {"font-size":"0.3rem"} }
const _hoisted_13 = { class: "high-light-children" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"color":"red","padding":"12px","background":"rgb(229, 246, 244)","font-weight":"600"} }
const _hoisted_16 = {
  class: "bold flex",
  style: {"color":"#000000"}
}
const _hoisted_17 = { class: "van-cell__title" }
const _hoisted_18 = { style: {"font-size":"0.32rem"} }
const _hoisted_19 = { class: "high-light" }
const _hoisted_20 = {
  key: 0,
  style: {"padding":"0"}
}
const _hoisted_21 = { class: "van-cell__title" }
const _hoisted_22 = { style: {"font-size":"0.3rem"} }
const _hoisted_23 = { class: "high-light-children" }
const _hoisted_24 = {
  key: 1,
  style: {"background-color":"#fff","margin-top":"15px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranking" }, "号卡排行榜TOP5", -1))
const _hoisted_26 = {
  key: 1,
  style: {"background-color":"#fff","padding-bottom":"10px"}
}
const _hoisted_27 = { style: {"font-weight":"600","padding":"10px","font-size":"14px","background":"rgb(229, 246, 244)","display":"flex"} }
const _hoisted_28 = { class: "groupLeader" }
const _hoisted_29 = { class: "grap" }
const _hoisted_30 = { style: {"position":"relative"} }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Collapse,
  CollapseItem,
  Icon,
} from "vant";
import { formatPercentage, formatThousands} from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'qySalesDaily',
  setup(__props) {

const route = useRoute();
const active = ref(0);
const field = ref("数码店维度");

const visible = ref(true);
const storePageData = ref<any>([]);
let time = dayjs(route.params.time as string).format("YYYY-MM-DD");
const getStorePageData = async () => {
  const res = await request({
    url: "/api/wx/uni-store/store-sales",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    storePageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getStorePageData();
const orderPageData = ref<any>([]);
const getOrderPageData = async () => {
  const res = await request({
    url: "/api/wx/uni-store/order-sales",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    orderPageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
const handleChange = (name: number) => {
  if (name === 0) {
    field.value = "数码店维度";
    getStorePageData();
  } else if (name === 1) {
    field.value = "号卡维度";
    getOrderPageData();
  }
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});
const activeNames = ref([]);
const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((active).value = $event)),
          onChange: handleChange,
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "数码店维度" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storePageData.value, (group, key, index) => {
                  return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_5, " ·" + _toDisplayString(key), 1),
                      _createVNode(_unref(Collapse), {
                        modelValue: activeNames.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event)),
                        border: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
                            return (_openBlock(), _createBlock(_unref(CollapseItem), {
                              key: itemIndex,
                              name: item.name + item.value,
                              border: false,
                              disabled: !item.headValueDataList
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.name) + "： ", 1),
                                    _createElementVNode("span", _hoisted_9, [
                                      _createTextVNode(_toDisplayString(item.type === "percentage"
                              ? _unref(formatPercentage)(item.value)
                              : _unref(formatThousands)(item.value)) + " （环比：", 1),
                                      _createElementVNode("span", {
                                        style: _normalizeStyle({
                              color: item.percentage >= 0 ? 'red' : 'green',
                            })
                                      }, _toDisplayString(`${
                                item.percentage >= 0 ? "+" : ""
                              }${_unref(formatPercentage)(item.percentage)}`), 5),
                                      _createTextVNode("） ")
                                    ])
                                  ])
                                ])
                              ]),
                              "right-icon": _withCtx(() => [
                                (
                        item.headValueDataList &&
                        item.headValueDataList.length > 0
                      )
                                  ? (_openBlock(), _createBlock(_unref(Icon), {
                                      key: 0,
                                      name: "arrow-down"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                (
                      item.headValueDataList &&
                      item.headValueDataList.length > 0
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.headValueDataList, (thirdLevelItem, thirdLevelIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          style: {"color":"#000000","padding-bottom":"10px"},
                                          class: "bold flex",
                                          key: thirdLevelIndex
                                        }, [
                                          _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(thirdLevelItem.name) + "： ", 1),
                                            _createElementVNode("span", _hoisted_13, [
                                              _createTextVNode(_toDisplayString(thirdLevelItem.type === "percentage"
                              ? _unref(formatPercentage)(thirdLevelItem.value)
                              : _unref(formatThousands)(thirdLevelItem.value)) + " （环比：", 1),
                                              _createElementVNode("span", {
                                                style: _normalizeStyle({
                              color:
                                thirdLevelItem.percentage >= 0
                                  ? 'red'
                                  : 'green',
                            })
                                              }, _toDisplayString(`${
                                thirdLevelItem.percentage >= 0 ? "+" : ""
                              }${_unref(formatPercentage)(thirdLevelItem.percentage)}`), 5),
                                              _createTextVNode("） ")
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["name", "disabled"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "号卡维度" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderPageData.value, (group, key, index) => {
                  return (_openBlock(), _createBlock(_unref(CellGroup), { key: index }, {
                    default: _withCtx(() => [
                      (key !== '号卡排行榜')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, " ·" + _toDisplayString(key), 1),
                            _createVNode(_unref(Collapse), {
                              modelValue: activeNames.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeNames).value = $event)),
                              border: false
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
                                  return (_openBlock(), _createBlock(_unref(CollapseItem), {
                                    key: itemIndex,
                                    name: item.name + item.value,
                                    border: false,
                                    disabled: !item.headValueDataList
                                  }, {
                                    title: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(item.name) + "： ", 1),
                                          _createElementVNode("span", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(item.type === "percentage"
                                ? _unref(formatPercentage)(item.value)
                                : _unref(formatThousands)(item.value)) + " （环比：", 1),
                                            _createElementVNode("span", {
                                              style: _normalizeStyle({
                                color: item.percentage >= 0 ? 'red' : 'green',
                              })
                                            }, _toDisplayString(`${
                                  item.percentage >= 0 ? "+" : ""
                                }${_unref(formatPercentage)(item.percentage)}`), 5),
                                            _createTextVNode("） ")
                                          ])
                                        ])
                                      ])
                                    ]),
                                    "right-icon": _withCtx(() => [
                                      (
                          item.headValueDataList &&
                          item.headValueDataList.length > 0
                        )
                                        ? (_openBlock(), _createBlock(_unref(Icon), {
                                            key: 0,
                                            name: "arrow-down"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      (
                        item.headValueDataList &&
                        item.headValueDataList.length > 0
                      )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.headValueDataList, (thirdLevelItem, thirdLevelIndex) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                style: {"color":"#000000","padding-bottom":"10px"},
                                                class: "bold flex",
                                                key: thirdLevelIndex
                                              }, [
                                                _createElementVNode("div", _hoisted_21, [
                                                  _createElementVNode("span", _hoisted_22, _toDisplayString(thirdLevelItem.name) + "： ", 1),
                                                  _createElementVNode("span", _hoisted_23, [
                                                    _createTextVNode(_toDisplayString(thirdLevelItem.type === "percentage"
                                ? _unref(formatPercentage)(thirdLevelItem.value)
                                : _unref(formatThousands)(thirdLevelItem.value)) + " （环比：", 1),
                                                    _createElementVNode("span", {
                                                      style: _normalizeStyle({
                                color:
                                  thirdLevelItem.percentage >= 0
                                    ? 'red'
                                    : 'green',
                              })
                                                    }, _toDisplayString(`${
                                  thirdLevelItem.percentage >= 0 ? "+" : ""
                                }${_unref(formatPercentage)(thirdLevelItem.percentage)}`), 5),
                                                    _createTextVNode("） ")
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["name", "disabled"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _hoisted_25,
                            (!group.length)
                              ? (_openBlock(), _createBlock(_unref(Empty), {
                                  key: 0,
                                  description: "暂无数据",
                                  "image-size": "100"
                                }))
                              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (itemchild, indexchild) => {
                                    return (_openBlock(), _createElementBlock("div", { key: indexchild }, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({
                          one: indexchild == 0,
                          two: indexchild == 1,
                          three: indexchild == 2,
                          other: indexchild > 2,
                        })
                                        }, _toDisplayString(indexchild + 1), 3),
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(itemchild.productName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", null, "当日激活量: " + _toDisplayString(_unref(formatThousands)(itemchild.dayActiveNum)), 1),
                                        _createElementVNode("div", _hoisted_30, " 本月累计激活量: " + _toDisplayString(_unref(formatThousands)(itemchild.monthActiveNum)), 1),
                                        _createElementVNode("div", null, "当日佣金: " + _toDisplayString(_unref(formatThousands)(itemchild.dayCommission)), 1),
                                        _createElementVNode("div", null, "本月累计佣金: " + _toDisplayString(_unref(formatThousands)(itemchild.monthCommission)), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ]))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})